
<template>
  <div class="mb-3 row">
    <div class="col">
      <div class="bg-100 shadow-none border card">
        <div class="flex-between-center row gx-0">
          <div class="d-flex align-items-center col-sm-auto">
            <h5 class="mb-0 p-3 text-primary fw-bold">
              이벤트 관리<span class="text-info fw-medium" />
            </h5>
          </div>

          <div class="form-group d-flex align-items-end gap-2 p-3">
            <select
              id="selclient"
              v-model="selectClient"
              class="me-2 form-select-sm select-month form-select"
              style="width:160px; display:inline;"
              @change="onClientChange"
            >
              <option
                v-for="client in clientList"
                :key="client.clientcode"
                :value="client"
              >
                {{ client.clientname }}
              </option>
            </select>

            <!-- 시작일 -->
            <div>
              <Datepicker
                id="startSelectedDate"
                v-model="startSelectedDate"
                :input-class="'custom-datepicker-input'"
                format="yyyy-MM-dd"
                :max-date="endSelectedDate ?? undefined"
              />
            </div> 

            <!-- 종료일 -->
            <div>
              <Datepicker
                id="endSelectedDate"
                v-model="endSelectedDate"
                :input-class="'form-select form-select-sm select-month me-2'"
                format="yyyy-MM-dd"
                :min-date="startSelectedDate ?? undefined"
              />
            </div>

            <select
              id="selstatus"
              v-model="selStatus"
              class="me-2 form-select-sm select-month form-select"
              style="width:160px; display:inline;"
              @change="onStatusChange"
            >
              <option
                v-for="(item,i) in selectStatusList"
                :key="i"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>

            <select
              v-model="selType"
              class="me-2 form-select-sm select-month form-select"
              style="width:160px; display:inline;"
              @change="onTypeChange"
            >
              <option
                v-for="(item,i) in selectTypeList"
                :key="i"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>

            <a
              class="btn btn-falcon-default btn-sm"
              @click="handleSearch"
            >
              <span
                class="mr-2 fs--2"
                data-fa-i2svg=""
              />검색
            </a>
          </div>
        </div>  
      </div>     
    </div>
  </div>

  <div class="h-100 card">
    <div class="d-flex flex-between-center py-2 border-200 border-bottom card-header">
      <h6 class="mb-0">
        이벤트 리스트
      </h6>
    </div>
    <div class="d-flex py-2 border-200 border-bottom card-header">
      <a
        class="me-2 btn btn-falcon-default btn-sm"
        @click="handleCompleted"
      >
        <span
          class="mr-2 fs--2"
          data-fa-i2svg=""
        />처리완료
      </a>
      <a
        class="btn btn-falcon-default btn-sm"
        @click="handleDelete"
      >
        <span
          class="mr-2"
          data-fa-i2svg=""
        />삭제
      </a>
    </div>
    <div class="d-flex align-items-center card-body">
      <div class="w-100">
        <CommGrid
          ref="commGridRef"
          :rows="loadResults"
          :columns="columnDefs"
          :is-check-box="true"
          :set-grid-height="null"
        />
      </div>
    </div>
  </div>


  <AlertModal ref="alertModalRef" />
</template>

<script setup lang="ts">

import moment from 'moment'
import axios from 'axios'
import CommGrid from '../components/CommGrid.vue'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { onMounted, ref} from 'vue';
import type { Client, User, EventListResult, ColumnDefinition } from '@/types/commontypes'
import AlertModal from "@/components/AlertModal.vue";

const clientList = ref<Client[]>([])

const startSelectedDate = ref<Date | null>(null)
const endSelectedDate = ref<Date | null>(null) 

const user = ref<User | null>(null)
const alertModalRef = ref();
// const isEditMode = ref(false)

// const selectClient = ref<Client | null>(null);

const selectClient = ref<Client>({
    clientcode:'',
    clientname:'',
    clientlevel:0,
    servicestate:0,
    regdt:''
})

// 이벤트 상태 
const selectStatusList = [
    { value: -1, label: '전체'}, 
    { value: 0, label: '종료'}, 
    {value: 1, label: '발생'}]
const selStatus = ref(-1)


const selectTypeList = [
    { value: -1, label: '전체'}, 
    { value: 1, label: '측정값 임계치'}, 
    { value: 2, label: '측정값 미수집'},
    { value: 3, label: '배터리 저전압'}
]
const selType = ref(-1)

const columnDefs = ref<ColumnDefinition[]>([]);

const commGridRef  = ref();
const checkedRows = ref<EventListResult[]>([]);

const loadResults = ref<EventListResult[]>([]);

onMounted(async () => {
    const res = await axios.get('/api/userinfo', { withCredentials: true });
    user.value = res.data.user;

    console.log("user info ", user);

    const today = new Date()
    const weekAgo = new Date()
    weekAgo.setDate(today.getDate() - 7)

    // 필요한 경우 포맷을 맞춰서 할당할 수도 있음
    startSelectedDate.value = weekAgo
    endSelectedDate.value = today
    
    getColumnInfo();
    LoadClientList();
})

function LoadClientList() {
	if(!user.value)
		return;

    const userjson = user.value;
    if(!userjson)
        return;

	var clientid = "all";
	var clientlevel = 1;
	if(userjson.clientlevel == 0) {
		clientid = 'all';
		clientlevel = 1;
	} else {
		clientid = userjson.clientcode;
		clientlevel = 1;
	}

	// 입력값을 변수에 담고 문자열 형태로 변환
	const data = JSON.stringify(
        { 'operator': "getClientlist", 
            'clientid' : clientid, 
            'clientlevel' : clientlevel
        }
    );
	
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		let result: Client[] = JSON.parse(xhr.responseText);
		// result = JSON.parse(result);

        result.sort((a, b) => {
            const a1 = a.clientname.toLowerCase();
            const b1 = b.clientname.toLowerCase();
            if (a1 < b1) return -1;
            if (a1 > b1) return 1;

            return 0;
        });

        clientList.value = [];
		for(let client of result) {
	        clientList.value.push(client);
    	}

        const savedClientCode = localStorage.getItem('selectedClientCode');
        let initialClient = clientList.value[0];
        // 저장된 client가 있고, 현재 리스트에 존재하면 해당 client 선택
        if (savedClientCode) {
            const foundClient = clientList.value.find(c => c.clientcode === savedClientCode);
            if (foundClient) {
                initialClient = foundClient;
            }
        }

        selectClient.value = initialClient

        LoadGridData();
	});    
}

function formatDateTime(value: unknown) {
    if (!value) return '';
    const stringValue = String(value)
    return moment(stringValue).format('YYYY-MM-DD HH:mm')
}

// 조회결과를 표시할 그리드의 컬럼정보를 구성함
function getColumnInfo() {
    const columnList: ColumnDefinition[] = [
        { field: 'deviceid', label: '아이디', labelClass: 'vgt-center-align', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'devicename', label: '이름', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'type', label: '종류', thClass: 'text-center', tdClass: 'text-center', formatFn: (value: unknown) => {
                const stringValue = String(value)
                const selectTypeMap = Object.fromEntries(
                    selectTypeList.map(item => [item.value, item.label])
                );

                return selectTypeMap[stringValue] || stringValue;
            }},
        { field: 'dfkey', label: '센서', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'sname', label: '센서명', thClass: 'text-center', tdClass: 'text-center'},
        { field: 'startdt', label: '발생일시', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
        { field: 'enddt', label: '종료일시', thClass: 'text-center', tdClass: 'text-center', formatFn: formatDateTime},
        { field: 'status', label: '상태', thClass: 'text-center', tdClass: 'text-center', formatFn: (value: string | unknown) => {
                return value === '0' ? '종료' : '발생'
            }},
        { field: 'msg', label: '메세지', thClass: 'text-center', tdClass: 'text-right'},
    ]

    columnDefs.value = [...columnList];
}


function LoadGridData() {
    if(!selectClient.value)
        return;

    const strStart = moment(startSelectedDate.value).format('YYYY-MM-DDTHH:mm:ss')
    const strEnd = moment(endSelectedDate.value).format('YYYY-MM-DDT23:59:59')

    const data = JSON.stringify({ 
        'operator': "getEventlist", 
        'clientcode' : selectClient.value.clientcode,
        'from' : strStart,
        'to' : strEnd,
        'status' : selStatus.value,
        'type' : selType.value
    });
   
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		const result : EventListResult[] = JSON.parse(xhr.responseText);
        const evtList: EventListResult[] = result.map(item => {
            const svlistJSON: Record<string,unknown>[] = JSON.parse(item.svlist)
            const fobj = svlistJSON.find(sitem => sitem.dfkey === item.dfkey)
            if(fobj)
                item.sname = fobj.sname as string

            return item
        })
        loadResults.value = [...evtList];
    });
}

// 선택된 이벤트 완료 처리 버튼
function handleCompleted() {
    if(!commGridRef.value) {
        return;
    }
    
    checkedRows.value = commGridRef.value.selectedRows;
    if(!checkedRows.value || checkedRows.value.length <= 0) {
        alertModalRef.value.showAlertModal("경고", "이벤트를 선택하세요.");
        return;
    }

    if(checkedRows.value.length > 1) {
        alertModalRef.value.showAlertModal("경고", "1개만 선택해 주세요.");
        return;
    }

    const selEventObj = checkedRows.value[0];
    
    // 입력값을 변수에 담고 문자열 형태로 변환
	const data = JSON.stringify({ 'operator': "updateEventSingle", 
        'myid' : selEventObj.myid, 
        'deviceid' : selEventObj.deviceid, 
        'dfkey': selEventObj.dfkey
        });
	
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		let result = JSON.parse(xhr.responseText);
        if(!result.err) {
            LoadGridData();
        } else {
            alertModalRef.value.showAlertModal("경고", `완료처리가 실패 했습니다. : ${result.err}`);
        }

    });
}

// 선택된 이벤츠 삭제 처리 버튼
function handleDelete() {
  if(!commGridRef.value) {
      return;
  }
  
  checkedRows.value = commGridRef.value.selectedRows;
  if(!checkedRows.value || checkedRows.value.length <= 0) {
      alertModalRef.value.showAlertModal("경고", "삭제할 이벤트를 선택하세요.");
      return;
  }

  if(checkedRows.value.length > 1) {
      alertModalRef.value.showAlertModal("경고", "1개만 선택해 주세요.");
      return;
  }

  const selEventObj = checkedRows.value[0];
    
    // 입력값을 변수에 담고 문자열 형태로 변환
	const data = JSON.stringify({ 'operator': "deleteEventSingle", 
        'myid' : selEventObj.myid, 
        'deviceid' : selEventObj.deviceid, 
        'dfkey': selEventObj.dfkey
        });
	
	// content-type을 설정하고 데이터 송신
	var xhr = new XMLHttpRequest();
	xhr.open('POST', '/ajax/ajaxcall');
	xhr.setRequestHeader('Content-type', "application/json");
	xhr.send(data);

	// 데이터 수신이 완료되면 표시
	xhr.addEventListener('load', function(){
		let result = JSON.parse(xhr.responseText);
        if(!result.err) {
            LoadGridData();
        } else {
            alertModalRef.value.showAlertModal("경고", `삭제가 실패 했습니다. : ${result.err}`);
        }

    });
}

function onClientChange() {
    const selClientCode = selectClient.value.clientcode;
    localStorage.setItem('selectedClientCode', selClientCode);

    LoadGridData();
}

function onStatusChange() {
    LoadGridData();
}

function onTypeChange() {
    LoadGridData();
}

// 디바이스 등록
function handleSearch() {
    LoadGridData();
}


</script>

<style lang="">

</style>